import { render, staticRenderFns } from "./totalBarGraph.vue?vue&type=template&id=78dfe780&"
import script from "./totalBarGraph.vue?vue&type=script&lang=ts&"
export * from "./totalBarGraph.vue?vue&type=script&lang=ts&"
import style0 from "./totalBarGraph.vue?vue&type=style&index=0&id=78dfe780&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports